<template>
  <FormControl :label="i18n.app.components.contract.conked_out_license_plate" @disabled="onSetDisabled">
    <input type="text" v-model="model[name]" @keyup="onKeyup($event.target.value)" @change="onChange($event.target.value)"
      class="form-control license" :class="getCountryCode()" placeholder :disabled="getIsDisabled()" />
  </FormControl>
</template>

<script>
import TextInput from "./TextInput";
import VehicleService from "@/services/VehicleService";
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";

const vehicleService = new VehicleService();

export default {
  name: "text-input-license-plate",
  props: ["label", "model", "name", "countryCode"],
  components: {
    TextInput,
    FormControl
  },
  mixins: [formControlMixin],
  methods: {
    getValue() {
      return this.model[this.name];
    },
    onKeyup(value) {
      this.model[this.name] = value.toUpperCase();
    },
    async onChange(value) {
      if (!value) {
        return;
      }

      /* First check internally for vehicle data  */
      let result = await this.tryInternalSearch(this.countryCode, value)

      /* Then check rdw for vehicle data */
      if (!result) {
        result = await this.tryRdwSearch(this.countryCode, value)
      }

      this.$emit("searched", result);
    },
    async tryInternalSearch(countryCode, value) {
      if (!config.company_vehicle.enabled || !config.company_vehicle.enabled_country_codes || !config.company_vehicle.enabled_country_codes.includes(countryCode)) {
        return;
      }

      this.$emit("search");

      try {
        return await vehicleService.searchByLicensePlateInternal(countryCode, value)
      } catch(e) {
        return;
      }
    },
    async tryRdwSearch(countryCode, value) {
      if (!config.rdw.enabled || !config.rdw.enabled_country_codes || !config.rdw.enabled_country_codes.includes(countryCode)) {
        return;
      }

      this.$emit("search");

      try {
        return await vehicleService.searchByLicensePlateRdw(countryCode, value)
      } catch(e) {
        return;
      }
    },
    getCountryCode() {
      return this.countryCode ? this.countryCode.toLowerCase() : null;
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  padding-left: 2rem;
  text-align: center;
}
</style>
